import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconColumnWide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconColumnWide"><Path d="M11.5 4H4.5C3.11929 4 2 5.11929 2 6.5V17.5C2 18.8807 3.11929 20 4.5 20H11.5V4Z" fill="currentColor"/><Path d="M12.5 20H19.5C20.8807 20 22 18.8807 22 17.5V6.5C22 5.11929 20.8807 4 19.5 4H12.5V20Z" fill="currentColor"/></CentralIconBase>;
});

export default IconColumnWide;
